// extracted by mini-css-extract-plugin
export var active = "_61-7";
export var container = "_61-0";
export var evenWidth = "_61-4";
export var large = "_61-5";
export var outlet = "_61-8";
export var slide = "_61-2";
export var small = "_61-6";
export var tab = "_61-3";
export var tabs = "_61-1";